export const entityType = {
	center: 0,
	doctor: 1,
	pharmacy: 2,
}